export { ProductPage as default } from 'routes/sign-up/payers/product/ProductPage'
export { getServerSideProps } from 'routes/sign-up/payers/product/helpers/getServerSideProps/getServerSideProps'
